import { atom } from "jotai";

export const usersState = atom({
  users: [],
  facilities: [],
});
